import { render, staticRenderFns } from "./NavExpediente.vue?vue&type=template&id=961bbf88&"
import script from "./NavExpediente.vue?vue&type=script&lang=js&"
export * from "./NavExpediente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports